import type { FolderColor } from "@bedrock/domain";

export const FOLDER_COLORS: readonly { value: FolderColor; label: string }[] = [
  { value: "lilac", label: "Lilac" },
  { value: "sage", label: "Sage" },
  { value: "sky", label: "Sky" },
  { value: "sand", label: "Sand" },
  { value: "clay", label: "Clay" },
  { value: "stone", label: "Stone" }
];

export function folderColorLabel(color: FolderColor): string {
  return FOLDER_COLORS.find((option) => option.value === color)?.label ?? "Lilac";
}
